import { ClassTypeEnum, RemovePripomienkaApi } from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import Uuid from '../model/Uuid';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new RemovePripomienkaApi(apiConfiguration(pripomienkyPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const removePripomienka = async (
  classType: ClassTypeEnum,
  type: string,
  year: number,
  index: number,
  uuid: Uuid,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.removePripomienka(
    classType,
    type,
    year,
    index,
    uuid,
    options,
  );
  return {
    responseCode: status,
  };
};
